__turbopack_context__.v({
  "swatch-group": "orZ5aq_swatch-group",
});
